var map = {
	"./box-white.svg": "14cb",
	"./brochure-white.svg": "6d6b",
	"./facebook-logo-white.svg": "9082",
	"./kpplogo.svg": "376b",
	"./kppslogen.svg": "f3bd",
	"./pantone-scale.jpg": "6863",
	"./service-photos/ablakozas-thumb - Copy.jpg": "9516",
	"./service-photos/ablakozas-thumb.jpg": "9199",
	"./service-photos/ablakozas.jpg": "8489",
	"./service-photos/braille-nyomtatas-thumb.jpg": "6f7f",
	"./service-photos/braille-nyomtatas.jpg": "0e54",
	"./service-photos/dobozragasztas-thumb.jpg": "4a39",
	"./service-photos/dobozragasztas.jpg": "49f8",
	"./service-photos/doboztervezes-thumb.jpg": "eddb",
	"./service-photos/doboztervezes.jpg": "91f2",
	"./service-photos/dombornyomas-thumb.jpg": "0eb9",
	"./service-photos/dombornyomas.jpg": "a477",
	"./service-photos/iv-ezust-arany-melegfoliazasa-thumb.jpg": "b368",
	"./service-photos/iv-ezust-arany-melegfoliazasa.jpg": "fede",
	"./service-photos/ivkasirozas-thumb.jpg": "ad8e",
	"./service-photos/ivkasirozas.jpg": "d247",
	"./service-photos/lakkozasi-eljarasok-thumb.jpg": "4310",
	"./service-photos/lakkozasi-eljarasok.jpg": "b1f3",
	"./service-photos/melegfoliazas-thumb.jpg": "5adb",
	"./service-photos/melegfoliazas.jpg": "270a",
	"./service-photos/nyomtatas-femgozolt-kartonra-thumb.jpg": "8095",
	"./service-photos/nyomtatas-femgozolt-kartonra.jpg": "6987",
	"./service-photos/ofszetnyomtatas-thumb.jpg": "21b7",
	"./service-photos/ofszetnyomtatas.jpg": "9841",
	"./service-photos/pregeles-fempregeles-thumb.jpg": "c5e8",
	"./service-photos/pregeles-fempregeles.jpg": "4336",
	"./service-photos/proof-nyomtatas-mintakeszites-thumb.jpg": "938b",
	"./service-photos/proof-nyomtatas-mintakeszites.jpg": "3c32",
	"./service-photos/reklamanyag-gyartas.jpg": "433a",
	"./service-photos/stancolas-thumb.jpg": "7f90",
	"./service-photos/stancolas.jpg": "753c",
	"./service-photos/virtualis-modellezes-thumb.jpg": "3253",
	"./service-photos/virtualis-modellezes.jpg": "630b",
	"./services-placeholder-big.jpg": "aa7d",
	"./services-placeholder.jpg": "6375",
	"./szechenyi2020.png": "3aca",
	"./szechenyiplus.png": "5a0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";